"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Briber = void 0;
const CardName_1 = require("../../CardName");
const constants_1 = require("../../constants");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
class Briber {
    constructor() {
        this.name = 'Briber';
        this.description = 'As an additional cost, pay 12 M€ to claim this milestone';
    }
    getScore(player) {
        return player.spendableMegacredits();
    }
    canClaim(player) {
        let target = 20;
        if (player.cardIsInEffect(CardName_1.CardName.VAN_ALLEN) || player.isCorporation(CardName_1.CardName.NIRGAL_ENTERPRISES)) {
            target -= constants_1.MILESTONE_COST;
        }
        return this.getScore(player) >= target;
    }
    static payBribe(player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 12, { title: 'Select how to pay for milestone' }));
    }
}
exports.Briber = Briber;
//# sourceMappingURL=Briber.js.map